import React, { Component } from 'react';
import Popover from '@material-ui/core/Popover';
import HelpOutline from '@material-ui/icons/HelpOutline';
import { createStyles, withStyles } from '@material-ui/core/styles';

const styles = createStyles({
  container: {
    display: 'inline'
  },
  content: {
    padding: 10,
    maxWidth: 600
  },
  outline: {
    width: 13,
    height: 13,
    cursor: 'pointer'
  }
});

type Props = {
  classes: any,
  content: string[] | string
};

type StateProps = {
  anchorEl: any,
  open: boolean
};

class PopoverHelp extends Component<Props, StateProps> {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: {},
      open: false,
    };
  }

  handleClick = (event) => {
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    return (
      <span className={this.props.classes.container}>
        <HelpOutline className={this.props.classes.outline} onClick={this.handleClick} />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          onClose={this.handleRequestClose}
        >
          <div className={this.props.classes.content}>
            {this.props.content}
          </div>
        </Popover>
      </span>
    );
  }
};

export default withStyles(styles)(PopoverHelp);



// WEBPACK FOOTER //
// ./src/views/Common/Popovers/Help.tsx